import { computed } from 'vue';
import store from '@/store';

export default class AppComponent {
	public standAloneLogin = computed((): boolean => {
		return store.getters.standAloneLogin();
	});
}
